import React                   from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	Col,
	Row
}                              from 'reactstrap';
import RoleRow                 from "../components/RoleManagement/RoleRow";
import { roleService }         from '../services/role.service';
import NotificationAlert
							   from 'react-notification-alert/index';
import { NotificationService } from '../services';

class RoleManagement extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			users: [],
			roles: []
		}
	}

	componentDidMount() {
		roleService.getRoleList().then(roles => {
			this.setState({roles: roles});
			this.refreshUserRoles();
		})
	}

	refreshUserRoles = () => {
		roleService.getManagedPeople().then(userRoles => {
			userRoles.sort((a, b) => {
				return a.InternalUser.Email > b.InternalUser.Email ? 1 : -1;
			})
			this.setState({users: userRoles})
		});
	}

	onSaveUser = (user) => {
		roleService.saveUserRole(user).then(resp => {
			this.refreshUserRoles();
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 2, "Users role has updated.  Logging them out and in will refresh permissions."));
		}).catch(err => {
			this.refs.notificationAlert.notificationAlert(NotificationService.notify('tc', 4, "Error: "+err+". Updating user role has failed."));
		})
	}

	render() {
		const {users, roles} = this.state;
		return (
			<>
				<NotificationAlert ref="notificationAlert" />
				<div className="content">
					<Row>
						<Col xs={12}>
							<Card>
								<CardHeader>
									<h2>Manage User Roles</h2>
								</CardHeader>
								<CardBody>
								</CardBody>
							</Card>
						</Col>
					</Row>
					{
						users.length > 0 && users.map(u => {
							return (
								<Row key={u.InternalUser.ID}>
									<Col xs={12}>
										<Card>
											<CardHeader>
												<h4></h4>
											</CardHeader>
											<CardBody>
												<RoleRow  user={u} roles={roles} onSaveHandler={this.onSaveUser} />
											</CardBody>
										</Card>
									</Col>
								</Row>
							)
						})
					}
				</div>
			</>
		)
	}
}

export default RoleManagement;